import { differenceInCalendarDays, format as dateFormat, isValid, Locale, parseISO } from 'date-fns'
import { enUS } from 'date-fns/locale'
import { TFunction } from 'i18next'

interface ParsedDate {
  formattedDate: string
  isoDate: string
}

interface DateUtil {
  parseISODate: (input: string, format?: string) => ParsedDate
  formatRelativePriorDate: (t: TFunction, date: Date, options?: { from?: Date; withTime?: boolean }) => string
}

export const date = (locale: Locale = enUS): DateUtil => ({
  parseISODate(input, format) {
    const date = parseISO(input)
    return {
      formattedDate: isValid(date)
        ? dateFormat(date, format ?? 'MMM dd', {
            locale,
          })
        : '',
      isoDate: input,
    }
  },

  formatRelativePriorDate(t, date, { from = new Date(), withTime = false } = {}) {
    const numberDaysAgo = differenceInCalendarDays(from, date)

    let dateString: string
    if (numberDaysAgo === 0) {
      dateString = t('Today', { context: 'label for the current day' })
    } else if (numberDaysAgo === 1) {
      dateString = t('Yesterday', { context: 'label for the prior day' })
    } else if (numberDaysAgo < 7 && !withTime) {
      dateString = dateFormat(date, 'EEEE', { locale })
    } else {
      dateString = dateFormat(date, 'MMM d', { locale })
    }

    return withTime ? `${dateString} at ${dateFormat(date, 'h:mm a', { locale })}` : dateString
  },
})
